
function Footer() {
    return (
        <footer id="footer" className="my-auto pb-4">
            <hr className="opacity-50 p-2" />
            <p className="text-center opacity-90 text-sm">©Copyright - <span className="italic animate-pulse">Sammy</span> - {new Date().getFullYear()}</p>
        </footer>
    );
}
  
  export default Footer;